import React, { useEffect } from "react";
import { isAxiosError } from "axios";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

import { User } from "~/domains/user/models/user";
import { env } from "~/env";
import { useUsers } from "~/hooks";
import { ROUTES } from "~/router";
import { usePageTitle } from "~/shared";
import { INTAKE_FORM_STATUS } from "~/shared.types";
import { useUserStore } from "~/stores";
import { JotformIframe } from "~/ui";
import { Footer } from "../components/Footer";
import Header from "../components/Header";

interface LocationState {
  user: User;
}

export const IntakeForm = () => {
  usePageTitle("Intake Form");

  const navigate = useNavigate();
  const hashedUserId = useUserStore((state) => state.hashedUserId);

  const location = useLocation();
  const { user } = (location.state ?? {}) as LocationState;

  const { checkIntakeFormStatus } = useUsers();

  const {
    data: intakeFormStatus,
    isLoading,
    isError,
    error,
  } = checkIntakeFormStatus(hashedUserId);

  useEffect(() => {
    if (!isLoading) {
      if (isError) {
        if (isAxiosError(error) && error.response?.status === 404) {
          navigate(ROUTES.signup);
        }
      } else {
        if (intakeFormStatus !== INTAKE_FORM_STATUS.PENDING) {
          navigate(ROUTES.fullLogin);
        }
      }
    }
  }, [intakeFormStatus, error, isError, isLoading]);

  if (!hashedUserId || !user) {
    return <Navigate to={ROUTES.signup} />;
  }

  const searchParams = {
    email: user.email,
    source: user.source,
    "name[first]": user.firstName,
    "name[last]": user.lastName,
  };

  return (
    <div className="grid min-h-screen grid-rows-[auto_1fr_auto]">
      <Header />

      <main className="overflow-y-auto">
        <JotformIframe
          formId={env.VITE_INTAKE_FORM_ID}
          searchParams={searchParams}
        />
      </main>

      <Footer />
    </div>
  );
};
